import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';

// Firebase configuration for AUTHENTICATION (same as customer app)
const authFirebaseConfig = {
  apiKey: "AIzaSyCvmjvnOdrmIw4az4bJUiTQ9RIPQcGHylw",
  authDomain: "lomra-auth.firebaseapp.com",
  databaseURL: "https://lomra-auth-default-rtdb.firebaseio.com",
  projectId: "lomra-auth",
  storageBucket: "lomra-auth.firebasestorage.app",
  messagingSenderId: "1081294234436",
  appId: "1:1081294234436:web:390c716956b092fbdded11",
  measurementId: "G-NGSFELF6LL"
};

// Firebase configuration for DATA
const dataFirebaseConfig = {
  apiKey: "AIzaSyB2WvUtMEuLxmpuK87nWr8iBlkZDWu19-8",
  authDomain: "amiable-octane-481820-n3.firebaseapp.com",
  projectId: "amiable-octane-481820-n3",
  storageBucket: "amiable-octane-481820-n3.firebasestorage.app",
  messagingSenderId: "580779815904",
  appId: "1:580779815904:web:ea05395fd43437ed317185",
  measurementId: "G-M6QH8D9HRR"
};

let authApp: FirebaseApp | null = null;
let dataApp: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;
let storage: FirebaseStorage | null = null;

try {
  // Initialize auth app
  authApp = initializeApp(authFirebaseConfig, 'auth-admin');
  auth = getAuth(authApp);
  
  // Initialize data app for Firestore and Storage
  dataApp = initializeApp(dataFirebaseConfig, 'data-admin');
  db = getFirestore(dataApp);
  storage = getStorage(dataApp);
  
  console.log('[Firebase Admin] Initialized successfully');
} catch (error) {
  console.error('[Firebase Admin] Error initializing Firebase:', error);
}

export { auth, db, storage };
